module.exports = __webpack_public_path__ + "static/media/purchase_orderActive.a7747b58.svg";